import { useState } from 'react';
import { Upload } from 'lucide-react';
import BotSelector from '../../../../../components/BotSelector/BotSelector';

export default function ImportFlowModal({ bots, initialBot, onClose, onImport }) {
  const [code, setCode] = useState('');
  const [name, setName] = useState('');
  const [bot, setBot] = useState(initialBot);
  const [importing, setImporting] = useState(false);

  async function handleConfirm() {
    if (!code.trim() || !bot || importing) return;
    setImporting(true);
    const imported = await onImport(bot, code, name);
    setImporting(false);
    if (imported) onClose();
  }

  return (
    <div className="manage-bots-modal-overlay" onClick={onClose}>
      <div className="manage-bots-modal" style={{ maxWidth: 440 }} onClick={e => e.stopPropagation()}>
        <div className="manage-bots-modal-header">
          <h3>
            <Upload size={14} style={{ display: 'inline', verticalAlign: 'middle', marginRight: '6px' }} />
            Importar Fluxo
          </h3>
          <button className="manage-bots-close" onClick={onClose}>
            <i className="fas fa-times" />
          </button>
        </div>
        <p className="text-sm text-white/40 mb-4">
          Cole o código <strong className="text-white">SX-</strong> de outro fluxo e escolha o bot que vai recebê-lo.
        </p>
        <input
          className="input3 w-full"
          placeholder="SX-XXXXXXXX"
          value={code}
          onChange={e => setCode(e.target.value)}
          autoFocus
        />
        <div className="mt-3">
          <input
            className="input3 w-full"
            placeholder="Nome do fluxo (opcional)"
            value={name}
            maxLength={50}
            onChange={e => setName(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && handleConfirm()}
          />
          <p className="text-xs text-white/30 mt-1">Se não informar, será usado o nome original + "(Importado)"</p>
        </div>

        <label className="text-xs font-bold text-white/90 uppercase tracking-wider mb-2 mt-4 block">
          Bot de destino
        </label>
        <BotSelector
          bots={bots}
          selectedBot={bot}
          onSelect={setBot}
          allBotsOption={false}
        />

        <div className="manage-bots-footer" style={{ marginTop: '1rem' }}>
          <div />
          <div className="manage-bots-footer-actions">
            <button className="btn-secondary" onClick={onClose}>Cancelar</button>
            <button className="btn-primary" onClick={handleConfirm} disabled={!code.trim() || !bot || importing}>
              {importing && <i className="fas fa-spinner fa-spin me-1" />}
              Importar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
